import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface AvulsoProduct {
  id: string;
  service_slug?: string;
  name: string;
  description?: string;
  price_brl: number;
  enabled: boolean;
}

let cache: AvulsoProduct[] | null = null;
let cacheAt = 0;
const TTL = 5 * 60 * 1000; // 5 min

export async function loadAvulsoProducts(): Promise<AvulsoProduct[]> {
  if (cache && Date.now() - cacheAt < TTL) return cache;
  const { data } = await supabase
    .from('platform_settings')
    .select('value')
    .eq('key', 'avulso_products')
    .maybeSingle();
  try {
    const parsed = data?.value
      ? (typeof data.value === 'string' ? JSON.parse(data.value) : data.value)
      : [];
    cache = Array.isArray(parsed) ? (parsed as AvulsoProduct[]) : [];
  } catch {
    cache = [];
  }
  cacheAt = Date.now();
  return cache!;
}

export function useAvulsoProduct(slug: string | undefined): AvulsoProduct | null {
  const [product, setProduct] = useState<AvulsoProduct | null>(null);

  useEffect(() => {
    if (!slug) return;
    loadAvulsoProducts().then(products => {
      const found = products.find(p => p.service_slug === slug && p.enabled);
      setProduct(found ?? null);
    });
  }, [slug]);

  return product;
}
